import { useMemo } from 'react';

/**
 * Custom hook to determine if a user can edit a comment
 */
export const useEditPermission = (
  onTextEdit?: (text: string) => void,
  authorEmail?: string,
  currentUserEmail?: string
) => {
  return useMemo(() => {
    return Boolean(
      onTextEdit &&
        authorEmail &&
        currentUserEmail &&
        authorEmail === currentUserEmail
    );
  }, [onTextEdit, authorEmail, currentUserEmail]);
};
